import { render, staticRenderFns } from "./overallKanban.vue?vue&type=template&id=6edbe242&scoped=true&"
import script from "./overallKanban.vue?vue&type=script&lang=js&"
export * from "./overallKanban.vue?vue&type=script&lang=js&"
import style0 from "./overallKanban.vue?vue&type=style&index=0&id=6edbe242&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edbe242",
  null
  
)

export default component.exports